import { render, staticRenderFns } from "./selectProducts.vue?vue&type=template&id=0fcdef46&scoped=true&"
import script from "./selectProducts.vue?vue&type=script&lang=js&"
export * from "./selectProducts.vue?vue&type=script&lang=js&"
import style0 from "./selectProducts.vue?vue&type=style&index=0&id=0fcdef46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcdef46",
  null
  
)

export default component.exports